import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { BsFillPlayFill } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import ListCourseSkeleton from "components/skeleton/ListCourseSkeleton";
import LectureNotFound from "components/Not-Found/LectureNotFound";
import {
  countArray,
  momentDateFormat,
  timeFormatWith12Hour,
  lectureAccess,
  lectureIsStarted,
  lectureIsExpired,
} from "config/utils";
import { lectureListView, personalizedLectureListView } from "services/lecture";
import Pagination from "react-js-pagination";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useCourse } from "context/context";
import { AiOutlineDownload, AiOutlineSearch } from "react-icons/ai";
import { errorResponse, failResponse, normalEncryptData } from "config/config";
import useDebounce from "hooks/useDebounce";
import { getSignedUrl } from "services/master";

const PersonalizedListLectures = () => {
  const { course } = useCourse();
  const [loading, setLoading] = useState(false);
  const [listLectures, setListLectures] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);

  const [isNext, setIsNext] = useState(false);
  const [isPrev, setIsPrev] = useState(false);
  const [nextId, setNextId] = useState("");
  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search, 300);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const paths = state?.path;

  const [submitLoading, setSubmitLoading] = useState(false);


  const getLecturesList = async (page = activePage, search = debounceValue) => {
    try {
      setLoading(true);

      const res = await personalizedLectureListView({
        search,
        page,
      });

      if (res.code === 200) {
        setListLectures(res.data.speciallectures.rows || []);
        setTotal(res.data.speciallectures.count || 0);
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  

  useEffect(() => {
    getLecturesList();
  }, [activePage, debounceValue]);

  useEffect(() => {
  setActivePage(1);
}, [debounceValue]);




  // navigation handler
  const navigationHandler = (id, startDate, endDate, time) => {

    navigate(`/dashboard/personalized-lecture/detail/${normalEncryptData(id, "route")}`)


  };


  const isExpired = (expireDate) => {
    if (!expireDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expDate = new Date(expireDate);
    expDate.setHours(0, 0, 0, 0);

    return expDate < today;
  };


  return (
    <>
      <div className="pagination_search_class">
        <div className="d-flex flex-column flex-md-row justify-content-between py-2 align-items-center">
          {/* Pagination on the top for mobile and left side for desktop */}
          <div className="d-flex mb-2 mb-md-0">
            {total > 10 ? (
              <div className="pagination_wrap">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  activeLinkClass={"active"}
                  onChange={(page) => setActivePage(page)}
                />
              </div>
            ) : null}
          </div>

          {/* Search bar on the bottom for mobile and right side for desktop */}
          <div className="search_bar_wrap d-flex" style={{ width: "275px" }}>
            <div className="search_bar">
              <input
                type="search"
                placeholder="Search"
                className="input"
                value={search}
                onChange={({ target }) => setSearch(target.value)}
              />
              <AiOutlineSearch />
            </div>
          </div>
        </div>
      </div>

      <div className="personalized_daily_lecture">
        <div className="meeting_content">
          <ul>
            {/* ************ Loading Component *********** */}
            {loading && (
              <>
                {countArray(8).map((data) => {
                  return (
                    <li key={data} className="p-0">
                      <ListCourseSkeleton height={90} />
                    </li>
                  );
                })}
              </>
            )}
            {/* iterate lectures */}
            <li className="lecture-card heading">
              <h6>Lecture Name</h6>
              <div className="play_btn">
                <b>Video</b>
              </div>
              <div className="date">
                <b>Teacher</b>
              </div>
              <div className="date">
                <b>Expire Date</b>
              </div>

              <div className="date">
                <b>Duration</b>
              </div>

            </li>
            {!loading &&
              listLectures.length > 0 &&
              listLectures.map(
                ({
                  LectureID,
                  LectureTitle,
                  Duration,
                  TeacherName,
                  speciallectures
                }) => {

                  const expireDate = speciallectures?.[0]?.expiredate;
                  const expired = isExpired(expireDate);

                  return (
                    <li
                      key={LectureID}
                      className={`lecture-card ${expired ? "disabled" : ""}`}
                      style={{
                        opacity: expired ? 0.5 : 1,
                        pointerEvents: expired ? "none" : "auto",
                        cursor: expired ? "not-allowed" : "pointer"
                      }}
                    >
                      <h6
                        onClick={() =>
                          !expired &&
                          navigationHandler(LectureID)
                        }
                      >
                        {LectureTitle || "N/A"}
                      </h6>

                      <div className="play_btn">
                        <span
                          onClick={() =>
                            !expired &&
                            navigationHandler(LectureID)
                          }
                        >
                          <span className="play-icon">
                            <BsFillPlayFill />
                          </span>
                        </span>
                      </div>

                      <div className="date">
                        <b>{TeacherName || "N/A"}</b>
                      </div>

                      <div className="date">
                        <b>
                          {expireDate || "N/A"}
                          {expired && (
                            <span className="text-danger ms-2">(Expired)</span>
                          )}
                        </b>
                      </div>

                      <div className="date">
                        <b>{Duration} mins</b>
                      </div>
                    </li>
                  );
                }
              )
            }

            {/* Not Found */}
            {!loading && listLectures.length <= 0 && (
              <>
                <LectureNotFound title="Lectures" />
              </>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default PersonalizedListLectures;
